import {
    CircularProgress,
    Grid,
    InputAdornment,
    TextField, Button,Box
  } from "@mui/material";
  import { Search, SentimentDissatisfied } from "@mui/icons-material";
  import React, { useEffect, useState } from "react";
  import './UploadModal.css';
  import UploadIcon from '@mui/icons-material/Upload';
  import { useSnackbar } from "notistack";
  import axios from "axios";
  import InputLabel from '@mui/material/InputLabel';
  import MenuItem from '@mui/material/MenuItem';
  import FormControl from '@mui/material/FormControl';
  import Select from '@mui/material/Select';
  import { config } from "../App";
  import Dialog from '@mui/material/Dialog';
    import DialogActions from '@mui/material/DialogActions';
    import DialogContent from '@mui/material/DialogContent';
    import DialogContentText from '@mui/material/DialogContentText';
    import DialogTitle from '@mui/material/DialogTitle';
    import { IconButton } from '@mui/material';
    import ClearIcon from '@mui/icons-material/Clear';
    import FormHelperText from '@mui/material/FormHelperText';
   import DesktopDatePicker from "react-datepicker";
 
   
    const UploadModal=()=>{

        const [open, setOpen] = useState(false);
        const { enqueueSnackbar } = useSnackbar();
        const[newVideo, setnewVideo] = useState({
          videoLink:"",
          previewImage:"",
          title:"",
          genre:"",
          contentRating:"",
          releaseDate:""
        })
          
  const handleValueChanges = e => { 
    setnewVideo({
      ...newVideo,
      [e.target.name]: e.target.value,
    });
    console.log("name",e.target.value);
  };
        const handleClickOpen = () => {
            setOpen(true);
        };

        const handleClose = () => {
            setOpen(false);
        };
        function toMonthName(monthNumber) {
          const date = new Date();
          date.setMonth(monthNumber - 1);
        
          return date.toLocaleString('en-US', {
            month: 'short',
          });
        }
        const submit = async () => {
          let URL = config.endpoint+`/videos`;
          console.log(newVideo);
          let splitdate = newVideo.releaseDate.split('-');
          console.log(splitdate[1]);
          splitdate[1] = toMonthName(splitdate[1]);
          let newdate = splitdate.reverse().join(" ");
          
          console.log("newdate", newdate);

            try{
              const response = await axios.post(URL, {videoLink:newVideo.videoLink, previewImage:newVideo.previewImage, title:newVideo.title,genre:newVideo.genre,contentRating:newVideo.contentRating,releaseDate:newdate});
              if(response.status===201){
                console.log(response);
                enqueueSnackbar('Video uploaded', {variant:"success"});
                setOpen(false);
              } 
            }
            catch(error){
                  enqueueSnackbar('Something went wrong. Check that the backend is running, reachable and returns valid JSON.', {variant:"error"});
            }
          
        };

            return(
                <>
                <Button variant="contained" style={{width:"6rem" , height:"2rem", 
                padding:"1rem", fontSize:"12px", textTransform: "capitalize", backgroundColor:"#4CA3FC", borderRadius:"4px"}} onClick={handleClickOpen}>
                  <UploadIcon fontSize="small"/>Upload</Button>

                  <Dialog open={open} onClose={handleClose} 
                  sx={{
                    "& .MuiDialog-container": {
                      "& .MuiPaper-root": {
                        width: "40%",
                        maxWidth: "500px", 
                        backgroundColor:"#292c2f" ,
                        color:"white"// Set your width here
                      },
                    },
                  }}>
                    <Grid container direction="row" justifyContent="space-between">
                        <DialogTitle>Upload Video</DialogTitle>
                        <IconButton aria-label="close"onClick={handleClose}>
                            <ClearIcon sx={{color:"white"}}/>
                            </IconButton>
                            
                    </Grid>
                  <DialogContent sx={{padding:"1rem"}}>
                  
                    <TextField
                        fullWidth
                        id="outlined-helperText"
                        name="videoLink"
                        label="Video Link"
                        type="link"
                        helperText="This link will be used to derive the video"
                        onChange={handleValueChanges}
                        sx={{marginBottom:"0.5rem", color:"#292c2f",
                            "& .MuiInputBase-root": {
                                color: 'white'
                            },
                            "& .MuiFormLabel-root": {
                                color: "rgba(246, 244, 244, 0.5)"
                            },
                            "&.MuiFormHelperText-root" :{
                                color:"#d1d1d1" 
                              }, "& .MuiFormLabel-root.Mui-focused": {
                                color: "rgba(246, 244, 244, 0.5)"
                            }}}
                       
                    />
                     <TextField
                        fullWidth
                        id="outlined-helperText"
                        label="Thumbnail image link"
                        name="previewImage"
                        defaultValue=""
                        helperText="This link will be used to preview the thumbnail image"
                        onChange={handleValueChanges}
                        sx={{marginBottom:"0.5rem", color:"#292c2f",
                            "& .MuiInputBase-root": {
                                color: 'white'
                            },
                            "& .MuiFormLabel-root": {
                                color: "rgba(246, 244, 244, 0.5)"
                            },
                            "&.MuiFormHelperText-root" :{
                                color:"#d1d1d1" 
                              },"& .MuiFormLabel-root.Mui-focused": {
                                color: "rgba(246, 244, 244, 0.5)"
                            }}}  
                    />
                    <TextField
                        fullWidth
                        id="outlined-helperText"
                        name="title"
                        label="Title"
                        defaultValue=""
                        helperText="The title will be representative text for image"
                        onChange={handleValueChanges}
                        sx={{marginBottom:"0.5rem", color:"#292c2f",
                            "& .MuiInputBase-root": {
                                color: 'white'
                            },
                            "& .MuiFormLabel-root": {
                                color: "rgba(246, 244, 244, 0.5)"
                            },
                            "&.MuiFormHelperText-root" :{
                                color:"#d1d1d1" 
                              }, "& .MuiFormLabel-root.Mui-focused": {
                                color: "rgba(246, 244, 244, 0.5)"
                            }}}
                           />

                          <TextField
                          fullWidth
                          id="outlined-select-currency"
                          select
                          label="Genre"
                          name="genre"
                          helperText="Genre will help in categorizing the video"
                          onChange={handleValueChanges}
                          sx={{marginBottom:"0.8rem", color:"#292c2f",
                            "& .MuiInputBase-root": {
                                color: 'white'
                            },
                            "& .MuiFormLabel-root": {
                                color: "rgba(246, 244, 244, 0.5)"
                            },
                            "&.MuiFormHelperText-root" :{
                                color:"#d1d1d1" 
                              }, "& .MuiFormLabel-root.Mui-focused": {
                                color: "rgba(246, 244, 244, 0.5)"
                            }}}
                          >
                        <MenuItem value="Education">Education</MenuItem>
                        <MenuItem value="sports">Sports</MenuItem>
                        <MenuItem value="comedy">Comedy</MenuItem>
                        
                    </TextField>

                    <TextField
                          fullWidth
                          id="outlined-select-currency"
                          select
                          label="Suitable age group for the clip"
                          name="contentRating"
                          helperText="This will be used to filter the age group suitability"
                          onChange={handleValueChanges}
                          sx={{marginBottom:"0.8rem", color:"#292c2f",
                            "& .MuiInputBase-root": {
                                color: 'white'
                            },
                            "& .MuiFormLabel-root": {
                                color: "rgba(246, 244, 244, 0.5)"
                            },
                            "&.MuiFormHelperText-root" :{
                                color:"#d1d1d1" 
                              }, "& .MuiFormLabel-root.Mui-focused": {
                                color: "rgba(246, 244, 244, 0.5)"
                            }, "& .MuiselectLabel-root.Mui-focused": {
                              color: "rgba(246, 244, 244, 0.5)"
                          }}}
                          >
                        <MenuItem value="7+">7+</MenuItem>
                        <MenuItem value="12+">12+</MenuItem>
                        <MenuItem value="18+">18+</MenuItem>
                        </TextField>

                        <TextField
                        fullWidth
                          id="outlined-date"
                          label="Upload and Publish date"
                          type="date"
                          name="releaseDate"
                          helperText="This will be used to sort videos"
                          onChange={handleValueChanges}
                          InputLabelProps={{ shrink: true }}
                          sx={{marginBottom:"0.5rem", color:"#292c2f",
                            "& .MuiInputBase-root": {
                                color: 'white'
                            },
                            "& .MuiFormLabel-root": {
                                color: "rgba(246, 244, 244, 0.5)"
                            },
                            "&.MuiFormHelperText-root" :{
                                color:"#d1d1d1" 
                              },"& .MuiFormLabel-root.Mui-focused": {
                                color: "rgba(246, 244, 244, 0.5)"
                            }}}
                         />
                    
                  </DialogContent>
                  <DialogActions sx={{justifyContent:"flex-start", paddingBottom:"1rem", paddingLeft:"1rem" }}  >
                    <Button variant="contained" onClick={submit} sx={{backgroundColor:"red",color:"white"}}>Upload Video</Button>
                    <Button onClick={handleClose} sx={{color:"white"}}>Cancel</Button>
                  </DialogActions>
                </Dialog>
                </>
            )
    }

    export default UploadModal;